export const { matches: mqTablet } = window.matchMedia("(min-width: 48em)");
export const { matches: mqLgTablet } = window.matchMedia("(min-width: 53em)");
export const { matches: mqDesktop } = window.matchMedia("(min-width: 62em)");
export const { matches: mqLgDesktop } = window.matchMedia("(min-width: 75em)");
